import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)



const router = new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: () => import('@/pages/'),
      meta: { title: '跃尚配音网 - 一站式真人配音服务平台', desc: '宣传片配音、广告配音、纪录片配音、专题配音，真人配音老师在线试音，5分钟极速报价', kw: '配音,宣传片配音,广告配音,纪录片配音,专题配音,真人配音,配音网' }
    },
    {
      path: '/question',
      name: 'question',
      component: () => import('@/pages/question'),
      meta: { title: '问题答疑 - 配音常见问题 - 跃尚配音网', desc: '配音价格、试音流程、交付时间、合作方式等常见问题解答。', kw: '配音问题,配音问答,试音流程' }
    },
    {
      path: '/question1',
      name: 'question1',
      component: () => import('@/pages/question'),
      meta: { title: '问题答疑 - 配音常见问题 - 跃尚配音网', desc: '配音价格、试音流程、交付时间等常见问题解答。', kw: '配音问题,配音问答' }
    },
    {
      path: '/video',
      name: 'video',
      component: () => import('@/pages/video'),
      meta: { title: '配音案例 - 宣传片广告纪录片配音作品 - 跃尚配音网', desc: '查看跃尚配音精选作品案例：宣传片、广告、纪录片、专题片配音真实作品演示。', kw: '配音案例,配音作品,宣传片配音案例' }
    },
    {
      path: '/signup',
      name: 'signup',
      component: () => import('@/pages/SignUp'),
      meta: { title: '注册 - 跃尚配音网', desc: '注册跃尚配音网账号，享受真人配音服务。', kw: '配音注册' }
    },
    {
      path: '/teacher',
      name: 'teacher',
      component: () => import('@/pages/teacher'),
      meta: { title: '配音老师大全 - 男声女声配音师在线试选 - 跃尚配音网', desc: '浏览跃尚配音全部真人配音师，男声、女声、多种风格在线试音筛选，快速找到合适的配音员。', kw: '配音老师,配音师,男声配音,女声配音,配音员' }
    },
    {
      path: '/login',
      name: 'Login',
      component: () => import('@/pages/Login'),
      meta: { title: '登录 - 跃尚配音网', desc: '登录跃尚配音网账号。', kw: '配音登录' }
    },
    {
      path: '/about',
      name: 'about',
      component: () => import('@/pages/about'),
      meta: { title: '关于我们 - 跃尚配音网', desc: '了解跃尚配音团队，专业提供宣传片、广告、纪录片、专题配音服务。', kw: '关于跃尚,配音公司' }
    }
  ],
  scrollBehavior (to, from, savedPosition) {
      // return 期望滚动到哪个的位置
      return { x: 0, y: 0 }
    }
})


export default router



// WEBPACK FOOTER //
// ./src/router/index.js